module.exports = __webpack_public_path__ + "img/logo-big-picture-medical-mark.d545df50.svg";